import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { routss } from './router';
import { store } from "./store"

Vue.use(VueRouter);

const router = new VueRouter({
  routes: routss,
  mode: "history"
});

//Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
